<template>
  <canvas :id="comp+'pe_chart'"></canvas>
</template>

<script>
import { Line } from "vue-chartjs";
import "chartjs-plugin-annotation";
import { commonMixins } from "../../../assets/mixins/common.js";
export default {
  name: "pe-chart",
  extends: Line,
  mixins: [commonMixins],
  props: ["chartData", "comp"],
  data() {
    return {
      labels: [],
      chdata: [],
      options: {
        maintainAspectRatio: true,
        legend: {
          display: false
        },
        scales: {
          xAxes: [
            {
              display: true
            }
          ],
          yAxes: [
            {
              display: true,
              gridLines: {
                zeroLineColor: "#e8e9ef",
                color: "#e8e9ef",
                drawBorder: true
              }
            }
          ]
        },
        elements: {
          line: {
            tension: 0.00001,
            borderWidth: 1
          },
          point: {
            radius: 1,
            hitRadius: 10,
            hoverRadius: 1,
            borderWidth: 2
          }
        },
        annotation: {
          annotations: [
            {
              drawTime: "afterDraw", // overrides annotation.drawTime if set
              id: "a-line-1", // optional
              type: "line",
              mode: "horizontal",
              scaleID: "y-axis-0",
              value: this.chartData.avg,
              borderColor: "rgb(54, 162, 235)",
              borderWidth: 2,
              // Fires when the user clicks this annotation on the chart
              // (be sure to enable the event in the events array below).
              onClick: function(e) {
                // `this` is bound to the annotation element
              }
            }
          ]
        }
      }
    };
  },
  created() {
    if (this.chartData) {
      this.setChartData();
    }
  },
  methods: {
    setChartData() {
      this.chartData.series.forEach((val, key) => {
        this.labels.push(this.getMonthYear(val[0].substring(0, val[0].indexOf("T"))));
        this.chdata.push(val[1]);
      });
      setTimeout(() => {
        this.configureChart();
      });
    },
    configureChart() {
      console.log("Configure");
      this.options["plugins"] = {
        datalabels: {
          display: false,
          align: "top",
          anchor: "end"
        }
      };
      var ctx_div = document
        .getElementById(this.comp + "pe_chart")
        .getContext("2d");
      var chart = new Chart(ctx_div, {
        // The type of chart we want to create
        type: "line",
        // The data for our dataset
        data: {
          labels: this.labels,
          datasets: [
            {
              label: "",
              backgroundColor: "transparent",
              borderColor: "#6ebe73",
              pointBackgroundColor: "#ffffff",
              data: this.chdata
            }
          ]
        },
        // Configuration options go here
        options: this.options
      });
    }
  },
  mounted() {
    // if (this.chartData) this.configureChart();
  }
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/views/indices-data/indices-charts/peChart.vue